import { useDispatch } from 'react-redux'
import { openScreen, updateScreenParams } from '@slices/uiSlice'

// Jackpot screen navigation, kept out of components. Every drill-down pushes
// another entry onto the existing generic sidebar screen stack (uiSlice
// `sidebar.history`) — the same mechanism Tournaments uses, just one level
// deeper here (Jackpot -> Detail -> Tickets/BetTickets).
export const useJackpotNavigation = () => {
  const dispatch = useDispatch()

  const onViewJackpot = (jackpot, viewType) => {
    dispatch(
      openScreen({
        key: 'jackpotDetail',
        title: jackpot?.name ?? 'Jackpot',
        screen: 'JACKPOT_DETAIL',
        params: { jackpot, viewType },
      })
    )
  }

  // "My Win Chance" / "My Contribution %" in the detail screen -> the active
  // jackpot's own ticket list (all of my tickets, grouped by day).
  const onViewTickets = (jackpotId) => {
    dispatch(
      openScreen({
        key: 'jackpotTickets',
        title: 'Jackpot',
        screen: 'JACKPOT_TICKETS',
        params: { jackpotId },
      })
    )
  }

  // A "My Contributions" row's ticket count -> that bet's own ticket ids,
  // expanded from its range. The already-fetched contributions list travels
  // in params (mirrors defenderV2 passing the same array down) — no refetch.
  const onViewBetTickets = (contributions, betId) => {
    dispatch(
      openScreen({
        key: 'jackpotBetTickets',
        title: 'Jackpot',
        screen: 'JACKPOT_BET_TICKETS',
        params: { contributions, betId },
      })
    )
  }

  // Persists the Active/History tab choice onto the JACKPOT stack entry so it
  // survives a drill-down + back (the entry stays in the array; only the
  // component instance reading it remounts).
  const onSelectJackpotTab = (tabKey) => {
    dispatch(updateScreenParams({ activeTab: tabKey }))
  }

  return { onViewJackpot, onViewTickets, onViewBetTickets, onSelectJackpotTab }
}
